import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CartDrawer from '../components/CartDrawer';
import { useCart } from '../contexts/CartContext';
import { ComplianceBanner } from '../hooks/useConfig';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const { isCartOpen, toggleCart } = useCart();

  return (
    <div className="flex flex-col min-h-screen">
      <a href="#main-content" className="skip-to-content">
        Skip to content
      </a>
      <ComplianceBanner />
      <Header />
      <main id="main-content" className="flex-grow" tabIndex={-1}>
        {children}
      </main>
      <CartDrawer isOpen={isCartOpen} onClose={() => toggleCart(false)} />
      <Footer />
    </div>
  );
};

export default MainLayout;